import { RootState } from 'editor/src/store/index';

const isSampleFlagChangeAllowed = (state: RootState) => state.hostSettings.allowSampleFlagChange;

export default isSampleFlagChangeAllowed;
